import {Component, OnInit, ViewChild} from '@angular/core';
import {HrService} from './hr.service';
import {NewEmployeePopUpComponent} from './new-employee-pop-up/new-employee-pop-up.component';
import {FabMessageService} from '@fabric/components/message';
import {AuthenticationService} from '../core/authentication/authentication.service';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {FabThemeService} from '@fabric/components/theme';
import {NewTeamPopUpComponent} from './new-team-pop-up/new-team-pop-up.component';
import {AdUser} from '../admin/models/ad-user';
import {SelectionModel} from '@angular/cdk/collections';
import {MatTableDataSource} from '@angular/material/table';
import {ManagerFilter} from '../manager/managerFilter';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {ManagerService} from '../manager/manager.service';
import {AllRequestPopUpComponent} from '../manager/allrequest-pop-up/all-request-pop-up.component';
import {NewPublicHolidayComponent} from './new-public-holiday/new-public-holiday.component';
import {PublicHoliday} from '../admin/models/publicHoliday.model';
import {ExcelUtil} from '../common/web-workers/excel-export.worker';
import {writeFile} from 'xlsx';
import {EmployeeDetailsPopUpComponent} from './employee-details-pop-up/employee-details-pop-up.component';
import {EditEmployeePopUpComponent} from './edit-employee-pop-up/edit-employee-pop-up.component';
import {Team} from '../admin/models/team.model';
import {EditTeamPopUpComponent} from './edit-team-pop-up/edit-team-pop-up.component';
import {Vacation} from '../admin/models/vacation.model';
import {WorkAbroad} from '../admin/models/workAbroad.model';
import {Employee} from '../admin/models/employee.model';
import {AbsenceCalendarPopUpComponent} from '../absence-calendar-pop-up/absence-calendar-pop-up.component';
import {HrDocs} from '../admin/models/hrDocs.model';
import {HrFilter} from './hrFilter';
import {map, Observable, shareReplay} from 'rxjs';
import {
    EmployeeVacationAllowanceOverrideComponent
} from './employee-vacation-allowance-override/employee-vacation-allowance-override.component';
import {HttpErrorResponse} from '@angular/common/http';
import {DeclinePopUpComponent} from '../decline-pop-up/decline-pop-up.component';
import {MatSelect} from '@angular/material/select';
import * as XLSX from 'xlsx';
import {ImportExcel} from '../admin/models/importExcel.model';
import {EditWorkAbroadComponent} from './edit-work-abroad-pop-up/edit-work-abroad-pop-up.component';

@Component({
    selector: 'app-hr',
    templateUrl: './hr.component.html',
    styleUrls: ['./hr.component.scss']
})
export class HrComponent implements OnInit {

    public selection = new SelectionModel<AdUser>(true, []);
    public people: AdUser[] = [];
    public dataSource = new MatTableDataSource<AdUser>(this.people);

    public employeeData = {} as any;
    public publicHolidayData = {} as any;
    public teamData = {} as any;
    public dataSourceVacation: MatTableDataSource<any> = new MatTableDataSource<any>([]);
    public dataSourceVacationAll: MatTableDataSource<any> = new MatTableDataSource<any>([]);
    public dataSourceSwitchVacation: MatTableDataSource<any> = new MatTableDataSource<any>([]);
    public dataSourceWork: MatTableDataSource<any> = new MatTableDataSource<any>([]);
    public dataSourceSwitchWork: MatTableDataSource<any> = new MatTableDataSource<any>([]);
    public dataSourcePublicHoliday: MatTableDataSource<PublicHoliday> = new MatTableDataSource<PublicHoliday>([]);
    public dataSourceEmployee: MatTableDataSource<any> = new MatTableDataSource<any>([]);

    public backupVacationSwitchData: any[] = [];
    public backupWorkAbroadSwitchData: any[] = [];
    public backupVacationData: any[] = [];
    public backupVacationDataAll: any[] = [];
    public backupWorkAbroadData: any[] = [];
    public backupEmployeeData: any[] = [];
    public displayErrorMessage = 'Error Fetching Organisation Data';
    public searchPlaceholder : string = 'Search';

    public fieldNames = ['firstName', 'lastName', 'dateCreated', 'halfDay', 'startDate', 'endDate',
        'numberOfAnnualLeaveDays', 'requestStatus', 'absenceType', 'absenceReason', 'decline'];
    public displayNames = ['First Name', 'Last Name', 'Date Created', 'Half day', 'Start Date', 'End Date',
        'Total Absence', 'Request Status', 'Absence Type', 'Absence Reason', 'Decline'];

    public fieldNamesVacationAllRequest = ['firstName', 'lastName', 'contractType', 'holidayTaken', 'vacationAllowanceRemaining', 'vacationAllowanceCarryover'];
    public displayNamesVacationAllRequest = ['First Name', 'Last Name', 'Employee Type', 'Holidays Taken', 'Holidays Left',
        'Carry Over For this Year'];

    public fieldNamesWork = ['firstName', 'lastName', 'country', 'dateCreated', 'startDate', 'endDate',
        'numberOfAnnualLeaveDays', 'numberOfWorkAbroadDays', 'lastDayWorking', 'firstDayBack', 'requestStatus', 'approve', 'decline'];
    public displayNamesWork = ['First Name', 'Last Name', 'Country', 'Date Created', 'Start Date', 'End Date',
        'Annual Leave Length', 'Work Abroad Length', 'Last Day in Ireland', 'Date back in Ireland', 'Approval Status', 'Approve', 'Decline'];

    public fieldNamesWorkAllRequest = ['edit', 'firstName', 'lastName', 'gmin', 'teamName', 'contractType', 'requestStatus',
        'country', 'startDate', 'endDate', 'numberOfWorkAbroadDays', 'numberOfAnnualLeaveDays', 'workAbroadNegativeCarryOver', 'lastDayWorking', 'firstDayBack'];
    public displayNamesWorkAllRequest = ['Edit', 'First Name', 'Last Name', 'GMIN', 'Organization', 'Employee Type', 'Status',
        'Country', 'Start Date', 'End Date', 'Work Abroad Days Taken', 'Annual Leave Length', 'Negative Carry Over', 'Last Day in Ireland', 'Date Back to Ireland'];

    public fieldNamesPublicHoli = ['holidayDate', 'holidayName', 'fixed', 'halfDay', 'shutdownDay', 'delete'];
    public displayNamesPublicHoli = ['Date', 'Name', 'Fixed', 'Half Day', 'Shutdown Day', 'Delete'];

    public employeeFieldNames = ['firstName', 'lastName', 'gmin', 'teamName', 'contractType', 'location', 'startDate', 'vacationAllowanceRemaining', 'workAbroadAllowanceRemaining',
        'editEmployee', 'override'];
    public employeeDisplayNames = ['First Name', 'Last Name', 'GMIN', 'Organization', 'Employee Type', 'Location', 'Start Date', 'Remaining Holiday Allowance', 'Remaining WorkAbroad Allowance',
        'Edit', 'Override'];

    public dataSourceTeam: MatTableDataSource<Team> = new MatTableDataSource<Team>([]);
    public teamFieldNames = ['teamName', 'managerName', 'altManagerName', 'edit'];
    public displayTeamFieldNames = ['Name', 'Manager', 'Alternative Manager', 'Edit Team'];

    public isPageLoading = false;
    public filterEntity: ManagerFilter;
    public employeeEntity: HrFilter;
    public isChecked = false;
    public refreshLoading = false;
    public refreshLoadingEmployee = false;
    public isClosed = true;
    public stringIOFormat = true;
    public searchValue = '';
    public isExcelExporting = false;
    public displayValuePersonal = new Map<string, string>();
    public displayValueWork = new Map<string, string>();
    public displayValueEmployees = new Map<string, string>();
    public getTeamName = new Map<string, string>();
    public getDisplayValue = new Map<string, string>();
    public getDisplayValueWork = new Map<string, string>();
    public getDisplayValueEmployees = new Map<string, string>();
    public getTeamID = new Map<string, string>();
    public year: string[] = [];
    public yearListInPublicHoliday: string[] = [];
    public defaultPlaceHolder = String(new Date().getFullYear());
    public listOfTeamName: string[] = [];
    public employeeHandBookPdf = {} as HrDocs;
    public allValue: any[] = [];
    public gminValue = '';
    public employeeList: Employee[] = [];
    public currentYear = '';
    public selectedYear = '';
    public show = false;
    public buttonName: string = 'Show Url';
    public value: string = '';
    public managerNames: string[] = [];
    public altManagerNames: string[] = [];
    public newUser: any;
    public peopleSearchResults: any [] = [];
    public selectedPerson: any;
    public searchSubscription: any;
    public populateFormData = {} as AdUser;

    public nameArray: any[] = [];
    public countrySettingsCode: any;
    public clearIconClicked: boolean | undefined;

    public file: any;
    public requiredExcelHeadings: string[][] = [[
        'GMIN',
        'First Name',
        'Last Name',
        'Employee Type',
        'Is Manager',
        'Is HR',
        'Supervisory Organization',
        'Location',
        'Manager',
        'Manager GMIN',
        'Manager Email Address',
        'Hire Date',
        'Email - Primary Work'
    ]];
    public excelHeadings: any;
    public excelData: any;

    public handleExportExcel: any = [];

    public exportAvailable = false;
    public importCompleted = false;


    @ViewChild('employeesPaginator', {static: false})
    set employeesPaginator(value: MatPaginator) {
        if (this.dataSourceEmployee) {
            this.dataSourceEmployee.paginator = value;
        }
    };

    @ViewChild('personalPaginator', {static: false})
    set personalPaginator(value: MatPaginator) {
        if (this.dataSourceVacation) {
            this.dataSourceVacation.paginator = value;
        }
    };

    @ViewChild('personalPaginatorAll', {static: false})
    set personalAllPaginator(value: MatPaginator) {
        if (this.dataSourceVacationAll) {
            this.dataSourceVacationAll.paginator = value;
        }
    };

    @ViewChild('switchPersonalPaginator', {static: false})
    set switchPersonalPaginator(value: MatPaginator) {
        if (this.dataSourceSwitchVacation) {
            this.dataSourceSwitchVacation.paginator = value;
        }
    };

    @ViewChild('workAbroadPaginator', {static: false})
    set workAbroadPaginator(value: MatPaginator) {
        if (this.dataSourceWork) {
            this.dataSourceWork.paginator = value;
        }
    };

    @ViewChild('switchWorkAbroadPaginator', {static: false})
    set switchWorkAbroadPaginator(value: MatPaginator) {
        if (this.dataSourceSwitchWork) {
            this.dataSourceSwitchWork.paginator = value;
        }
    };

    @ViewChild('teamSelect') teamSelect: MatSelect | undefined;
    searchTxt : any;



    @ViewChild('publicPaginator', {static: false})
    set publicPaginator(value: MatPaginator) {
        if (this.dataSourcePublicHoliday) {
            this.dataSourcePublicHoliday.paginator = value;
        }
    };

    @ViewChild('teamPaginator', {static: false})
    set teamPaginator(value: MatPaginator) {
        if (this.dataSourceTeam) {
            this.dataSourceTeam.paginator = value;
        }
    };

    @ViewChild('employeeTable', {read: MatSort, static: false})
    set sortEmployeeTable(value: MatSort) {
        if (this.dataSourceEmployee) {
            this.dataSourceEmployee.sort = value;
        }
    };

    @ViewChild('workAbroadAll', {read: MatSort, static: false})
    set sortWorkAbroadAll(value: MatSort) {
        if (this.dataSourceSwitchWork) {
            this.dataSourceSwitchWork.sort = value;
        }
    };

    @ViewChild('personalTable', {read: MatSort, static: false})
    set sortPersonalTable(value: MatSort) {
        if (this.dataSourceVacation) {
            this.dataSourceVacation.sort = value;
        }
    };

    @ViewChild('personalTableAll', {read: MatSort, static: false})
    set sortPersonalTableAll(value: MatSort) {
        if (this.dataSourceVacationAll) {
            this.dataSourceVacationAll.sort = value;
        }
    };

    @ViewChild('workAbroadTable', {read: MatSort, static: false})
    set sortWorkAbroadTable(value: MatSort) {
        if (this.dataSourceWork) {
            this.dataSourceWork.sort = value;
        }
    };

    @ViewChild('publicHolidayTable', {read: MatSort, static: false})
    set sortPublicHolidayTable(value: MatSort) {
        if (this.dataSourcePublicHoliday) {
            this.dataSourcePublicHoliday.sort = value;
        }
    };

    @ViewChild('teamTable', {read: MatSort, static: false})
    set sortTeamTable(value: MatSort) {
        if (this.dataSourceTeam) {
            this.dataSourceTeam.sort = value;
        }
    };

    constructor(
        private readonly hrService: HrService,
        private readonly managerService: ManagerService,
        private readonly messageService: FabMessageService,
        private readonly authService: AuthenticationService,
        public readonly dialog: MatDialog,
        public readonly themeService: FabThemeService,
    ) {
        this.filterEntity = new ManagerFilter();
        this.employeeEntity = new HrFilter();
    }

    ngOnInit(): void {
        this.countrySettingsCode = localStorage.getItem('CountryCode');
        this.currentYear = String(new Date().getFullYear());
        this.filterEntity.year = this.currentYear;
        this.employeeEntity.year = this.currentYear;
        this.gminValue = this.authService.userInfo.gmin || '';
        this.managerNames = [];
        this.altManagerNames = [];
        this.hrService.getTeams().subscribe({
            next: (value) => {
                this.teamData = value;
                this.dataSourceTeam.data = value;
                this.getListOfTeamId();
            },
            error: () => {
                this.messageService.displayErrorMessage('Error Fetching Organization Data');
                this.isPageLoading = false;
            }
        });
        this.hrService.getEmployeeByLocation(this.countrySettingsCode).subscribe({
            next: (data) => {
                this.employeeData = data;
                this.employeeList = data;
                this.getYearForFilter();
                this.dataSourceEmployee.data = this.hrService.allEmployeeData(this.employeeData, this.getTeamName, this.currentYear);
                this.allValue = this.hrService.getData(this.employeeData, this.getTeamName);
                this.tableData(this.allValue);
                this.getEmployeeNameArray();
                this.calculateDisplayValues(this.currentYear, []);
                this.calculateEmployeesCard([]);
                this.getTeamDetails(this.teamData);
                this.refreshEmployee();
            }, error: () => {
                this.refreshLoading = false;
                this.messageService.displayErrorMessage(this.displayErrorMessage);
                this.isPageLoading = false;
            },
            complete: () => {
                this.isPageLoading = false;
            }
        });
        this.isPageLoading = true;
        this.refreshLoadingEmployee = true;
    }

    /**
     * When user clicks on a certain tab, only then is the method for that screen loaded
     * @param event
     */
    tabSelected(event: any) {
        if (event.tab.textLabel === 'Public Holidays') {
            this.fetchPublicHoliday(this.currentYear);
        } else if (event.tab.textLabel === 'Employee Handbook') {
            this.getHrDocs();
        } else if (event.tab.textLabel === 'Organizations') {
            this.refreshTeam();
        }
    }

    /**
     * sort startDate employee table and convert to ISO string
     */
    sortEmployeeStartDate() {
        for (const element of this.dataSourceEmployee.data) {
            if (element.startDate.includes('/')) {
                const str = element.startDate;
                const [day, month, year] = str.split('/');
                element.startDate = new Date(+year, +month - 1, +day).toISOString();
            }
        }
    }

    /**
     * sort startDate and endDate personal table and convert to ISO string
     */
    sortPersonalStartDate() {
        for (const element of this.dataSourceVacation.data) {
            if (element.startDate.includes('/')) {
                const startDate = element.startDate;
                const endDate = element.endDate;
                const [day, month, year] = startDate.split('/');
                const [dayEnd, monthEnd, yearEnd] = endDate.split('/');
                element.startDate = new Date(+year, +month - 1, +day).toISOString();
                element.endDate = new Date(+yearEnd, +monthEnd - 1, +dayEnd).toISOString();
            }
        }

        for (const element of this.dataSourceVacationAll.data) {
            if (element.startDate.includes('/')) {
                const startDate = element.startDate;
                const endDate = element.endDate;
                const [day, month, year] = startDate.split('/');
                const [dayEnd, monthEnd, yearEnd] = endDate.split('/');
                element.startDate = new Date(+year, +month - 1, +day).toISOString();
                element.endDate = new Date(+yearEnd, +monthEnd - 1, +dayEnd).toISOString();
            }
        }
    }

    /**
     * filter team table by name selected in dropdown
     * @param teamName
     */
    filterTeamsBySelectedTeamName(teamName: string): Team[] {
        if (this.clearIconClicked) {
            this.dataSourceTeam.data = this.teamData;
            this.getTeamDetails(this.teamData);
            this.getTeamName = new Map();
            this.clearIconClicked = false;
            return this.teamData;
        } else {
            const teams = this.teamData.filter((team: { teamName: string; manager: string; alternateManager: string; }) =>
                team.teamName === teamName
                || team.manager === teamName
                || team.alternateManager === teamName);
            this.getTeamDetails(teams);
            return teams;
        }
    }

    /**
     * sort startDate and endDate work abroad table and convert to ISO string
     */
    sortWorkAbroadStartDate() {
        for (const element of this.dataSourceWork.data) {
            if (element.startDate.includes('/')) {
                const startDate = element.startDate;
                const endDate = element.endDate;
                const [day, month, year] = startDate.split('/');
                const [dayEnd, monthEnd, yearEnd] = endDate.split('/');
                element.startDate = new Date(+year, +month - 1, +day).toISOString();
                element.endDate = new Date(+yearEnd, +monthEnd - 1, +dayEnd).toISOString();
            }
        }
        for (const element of this.dataSourceSwitchWork.data) {
            if (element.startDate.includes('/')) {
                const startDate = element.startDate;
                const endDate = element.endDate;
                const [day, month, year] = startDate.split('/');
                const [dayEnd, monthEnd, yearEnd] = endDate.split('/');
                element.startDate = new Date(+year, +month - 1, +day).toISOString();
                element.endDate = new Date(+yearEnd, +monthEnd - 1, +dayEnd).toISOString();
            }
        }
    }

    /**
     *Helps to retrieve the manager name from the obtained GMIN
     *@param value The Team data to be processed.
     * */
    public getTeamDetails(value: Team[]) {
        let managerSplit = [];
        let altManagerSplit = [];
        let managerReplace = '';
        let altManagerReplace = '';
        for (let i = 0; i < value.length; i++) {
            let managerFound = false;
            let altManagerFound = false;

            if (this.employeeList) {
                for (const element of this.employeeList) {
                    const employee = element;

                    if (!managerFound && element.gmin === value[i].manager) {
                        const name = `${employee.firstName} ${employee.lastName}`;
                        this.managerNames[i] = name;
                        this.dataSourceTeam.data[i].managerName = name;
                        managerFound = true;
                    }

                    if (!altManagerFound && element.gmin === value[i].alternateManager) {
                        const name = `${employee.firstName} ${employee.lastName}`;
                        this.altManagerNames[i] = name;
                        this.dataSourceTeam.data[i].altManagerName = name;
                        altManagerFound = true;
                    }

                    if (managerFound && altManagerFound) {
                            break; // exit loop if both manager and alternative manager have been found
                        }
                    if (!managerFound) {
                        managerSplit = value[i].managerEmail.split("@");
                        managerReplace = managerSplit[0].replace('.', ' ').toUpperCase();
                        this.managerNames[i] = managerReplace
                        this.dataSourceTeam.data[i].managerName = managerReplace;
                    }
                    if (!altManagerFound) {
                        altManagerSplit = value[i].alternateManagerEmail.split("@");
                        altManagerReplace = altManagerSplit[0].replace('.', ' ').toUpperCase();
                        this.altManagerNames[i] = altManagerReplace;
                        this.dataSourceTeam.data[i].altManagerName = altManagerReplace;
                    }
                }
            }
        }
    }

    /**
     * Refreshes Personal vacation tracker table after changes
     * */
    public refreshPersonalTable(): void {
        this.refreshLoading = false;
        this.hrService.getEmployeeByLocation(this.countrySettingsCode).subscribe({
            next: (data) => {
                this.employeeData = data;
                this.employeeList = data;
                this.allValue = this.hrService.getData(this.employeeData, this.getTeamName);
                this.tableData(this.allValue);
                this.calculateDisplayValues(this.filterEntity.year, this.filterEntity.teamName);
                this.refreshLoading = false;
                this.filterTableDataSources();
            }, error: () => {
                this.refreshLoading = false;
                this.messageService.displayErrorMessage(this.displayErrorMessage);
            }
        });
        this.refreshLoading = false;
    }

    /**
     * Refreshes work abroad table
     */
    public refreshWorkAbroadTable() {
        this.dataSourceSwitchVacation.data = [];
        this.dataSourceSwitchWork.data = [];
        this.dataSourceVacation.data = [];
        this.dataSourceWork.data = [];
        this.refreshLoading = true;
        this.hrService.getEmployeeByLocation(this.countrySettingsCode).subscribe({
            next: (data) => {
                this.employeeData = data;
                this.allValue = this.hrService.getData(this.employeeData, this.getTeamName);
                this.tableData(this.allValue);
                this.calculateDisplayValues(this.filterEntity.year, this.filterEntity.teamName);
                this.refreshLoading = false;
                this.filterTableDataSources();
            }, error: () => {
                this.refreshLoading = false;
                this.messageService.displayErrorMessage(this.displayErrorMessage);
            }
        });
    }

    /**
     * Refreshes Employees table after changes
     */
    public refreshEmployee(): void {
        this.refreshLoading = false;
        this.hrService.getEmployeeByLocation(this.countrySettingsCode).subscribe({
            next: (data) => {
                this.employeeData = data;
                this.dataSourceEmployee.data = this.hrService.allEmployeeData(this.employeeData, this.getTeamName, this.currentYear);
                this.calculateEmployeesCard(this.filterEntity.teamName);
                this.refreshLoading = false;
                this.refreshPersonalTable();
                this.filterTableDataSources();
            }, error: () => {
                this.refreshLoading = false;
                this.messageService.displayErrorMessage(this.displayErrorMessage);
            }
        });
        this.refreshLoading = true;
    }

    /**
     * Refreshes Teams table after changes
     */
    public refreshTeam(): void {
        this.refreshLoading = false;
        this.dataSourceTeam.data = [];
        this.hrService.getTeams().subscribe({
            next: (value) => {
                this.dataSourceTeam.data = value;
                this.getTeamDetails(value);
                this.teamData = value;
                this.getListOfTeamId();
                this.refreshLoading = false;
            },
            error: () => {
                this.refreshLoading = false;
                this.messageService.displayErrorMessage('Error Fetching Team Data');
            }
        });
        this.refreshLoading = true;
    }

    /**
     * Getting DataSource table value for all mat tabs
     * @param data All employee details
     */
    public tableData(data: any) {
        const vacationData: any[] = [];
        const allVacationData: any[] = [];
        const workData: any[] = [];
        data.pendingVacation.forEach((val: any) => {
            if (val.requestStatus == 'PENDING') {
                vacationData.push(val);
            }
        });

        data.pendingVacation.forEach((val: any) => {
            allVacationData.push(val);
        });

        data.pendingWork.forEach((value: any) => {
            if (value.requestStatus == 'PENDING') {
                workData.push(value);
            }
        });
        this.dataSourceSwitchVacation.data = data.allVacationRequest;
        this.dataSourceSwitchWork.data = data.allWorkRequest;
        this.dataSourceVacation.data = vacationData;
        this.dataSourceVacationAll.data = allVacationData;
        this.dataSourceWork.data = workData;
        this.dataSourceEmployee.data = data.allVacationRequest;
        this.backupVacationSwitchData = this.dataSourceSwitchVacation.data;
        this.backupWorkAbroadSwitchData = this.dataSourceSwitchWork.data;
        this.backupVacationData = this.dataSourceVacation.data;
        this.backupVacationDataAll = this.dataSourceVacationAll.data;
        this.backupWorkAbroadData = this.dataSourceWork.data;
        this.backupEmployeeData = this.dataSourceEmployee.data;
        this.getEmployeeNameArray();
        this.sortEmployeeStartDate();
        this.sortPersonalStartDate();
        this.sortWorkAbroadStartDate();
    }

    /**
     * Gets a list of team ids
     */
    public getListOfTeamId() {
        this.teamData.forEach((value: any) => {
            this.listOfTeamName.push(value.teamName);
            this.getTeamID.set(value.teamName, value.id);
            this.getTeamName.set(value.id, value.teamName);
        });
        this.listOfTeamName = this.managerService.getUniqueValues(this.listOfTeamName).sort();
    }

    /**
     * Opens the EmployeeVacationOverridePopup, passing in the employeeList
     */
    public openOverridePopup(value: any): void {
        this.dialog.open(EmployeeVacationAllowanceOverrideComponent, {data: [value]}).afterClosed().subscribe(() => {
            this.refreshEmployee();
        });
    }

    /**
     * Opens a popup to create a new employee
     */
    public openNewEmployeePopup(): void {
        this.dialog.open(NewEmployeePopUpComponent, {data: {}}).afterClosed().subscribe(() => {
            this.refreshEmployee();
        });
    }

    /**
     * Opens a popup to create a new employee
     */
    public openEditEmployeePopup(data: any): void {
        this.dialog.open(EditEmployeePopUpComponent, {
            data: {
                employeeGmin: data.gmin,
                teamData: this.teamData
            }
        }).afterClosed().subscribe(() => {
            this.refreshEmployee();
            this.refreshLoading = false;
        });
    }

    /**
     * Opens a popup to create a new employee
     */
    public openNewTeamPopup(): void {
        this.dialog.open(NewTeamPopUpComponent, {data: {}}).afterClosed().subscribe(() => {
            this.refreshTeam();
        });
    }

    /**
     * Opens a popup to edit a team
     */
    public openEditTeamPopup(data: Team): void {
        this.dialog.open(EditTeamPopUpComponent, {data: data}).afterClosed().subscribe(() => {
            this.clearTeamDropdown('');
            this.refreshTeam();
        });
    }

    /**
     * Opens the AbsenceCalendarPopup, passing in the employeeList
     */
    public openAbsenceCalendarPopup(): void {
        this.dialog.open(AbsenceCalendarPopUpComponent, {data: [this.employeeList, 'hr']});
    }

    /**
     * Calls a service method to get a string representing a boolean value
     * @param bool The boolean value to check
     */
    public halfDayStatus(bool: boolean): string {
        return this.managerService.halfDayStatus(bool);
    }

    /**
     * Gets List of year by getting the Date created and Date started for vacation and work Abroad
     */
    public getYearForFilter() {
        this.year = [];
        this.employeeData.forEach((da: any) => {
            da.vacation.forEach((ta: any) => {
                this.year.push(this.managerService.getYear(ta.endDate));
            });
            da.workAbroad.forEach((val: any) => {
                this.year.push(this.managerService.getYear(val.endDate));
            });
        });
        this.year = this.managerService.getUniqueValues(this.year).sort();
    }

    /**
     * Opens All Request pop up, passing in the employee list, selected tab on UI, selected Mat tab Name,
     * and the year value selected in the UI
     */
    public openAllRequestPopup(data: any, tabName: string, year: string): void {
        if (this.isChecked) {

            let multiplyValue = 0.9;
            const dialogConfig = new MatDialogConfig();
            if (window.innerHeight > 700) {
                multiplyValue = 0.7;
                dialogConfig.maxHeight = window.innerHeight * multiplyValue;
                dialogConfig.minHeight = window.innerHeight * multiplyValue;
                dialogConfig.minWidth = window.innerWidth * 0.05;

            } else {
                dialogConfig.maxHeight = window.innerHeight * multiplyValue;
                dialogConfig.minHeight = window.innerHeight * multiplyValue;
                dialogConfig.minWidth = window.innerWidth * 0.05;
            }
            dialogConfig.data = [
                [this.allValue],
                data,
                tabName,
                year
            ];
            this.dialog.open(AllRequestPopUpComponent, dialogConfig);
        }
    }

    /**
     * Opens employee edit pop up, passing in the employee list, selected tab on UI, selected Mat tab Name,
     * and the list of year
     */
    public openEmployeeDetailsPopup(data: any): void {
        this.dialog.open(EmployeeDetailsPopUpComponent, {data: [this.allValue, data, this.year], height: '90%'});
    }

    /**
     * Opens New Holiday pop up, passing in the country details
     */
    public openNewPublicHolidayPopup(year: string) {
        this.dialog.open(NewPublicHolidayComponent, {data: this.countrySettingsCode}).afterClosed().subscribe(() => {
            this.refreshLoading = false;
            this.fetchPublicHoliday(year);
        });
    }

    /**
     * Deletes the holiday and refreshes the table
     */
    public deletePublicHoliday(id: string) {
        this.hrService.deletePublicHoliday(id).subscribe({
            next: () => {
                this.messageService.displayMessage('success');
                this.refreshLoading = false;
                this.fetchPublicHoliday(this.currentYear);
            }, error: (err: HttpErrorResponse) => {
                this.messageService.displayErrorMessage(err.error.errorMessage);
            }
        });

    }

    /**
     * Fetches the public holiday Data
     */
    public fetchPublicHoliday(year: string) {
        this.hrService.getPublicHoliday(this.countrySettingsCode).subscribe({
            next: (value) => {
                this.publicHolidayData = value;
                this.publicHolidayData.forEach((d: any) => {
                    this.yearListInPublicHoliday.push(this.hrService.getYear(d.holidayDate));
                });
                this.yearListInPublicHoliday = this.managerService.getUniqueValues(this.yearListInPublicHoliday).sort();
                this.dataSourcePublicHoliday.data = this.hrService.segregateYearAndPublicHoliday(this.publicHolidayData, year);
                this.dataSourcePublicHoliday.data.sort();
                this.refreshLoading = false;
            }
        });
        this.refreshLoading = true;
    }

    /**
     * Exports an excel of the table data
     */
    public exportExcel(tabName: string): void {
        let data: any[];
        let sheetName = '';
        if (tabName == 'vacation') {
            data = this.dataSourceVacation.data;
            sheetName = 'Vacation_Details';
        } else if (tabName == 'workAbroad') {
            data = this.dataSourceWork.data;
            sheetName = 'Work_Abroad';
        } else {
            data = this.dataSourcePublicHoliday.data;
            sheetName = 'Public_Holidays';
        }
        if (data.length > 0) {
            this.isExcelExporting = true;
            ExcelUtil.exportObjectArrayMultiThreaded(data, sheetName)
                .subscribe({
                    next: (workbook) => {
                        if (workbook) {
                            writeFile(workbook, sheetName + '.xlsx');
                            this.isExcelExporting = false;
                        }
                    },
                    error: () => {
                        this.messageService.displayErrorMessage('Failed to export Excel file');
                        this.isExcelExporting = false;
                    }
                });
        } else {
            this.messageService.displayErrorMessage('No data to export');
        }
    }

    /**
     * Exports the employee details and vacations
     */
    public exportEmployeeDetailsExcel(): void {
        this.isPageLoading = true;
        this.hrService.downloadEmployeeDetailsExcel(this.countrySettingsCode).subscribe({
            next: (blob) => {
                this.isPageLoading = false;
                if (blob.size !== 0) {
                    const downloadLink = document.createElement('a');
                    downloadLink.href = window.URL.createObjectURL(blob);
                    downloadLink.setAttribute('download', 'Employee Details.xlsx');
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    document.body.removeChild(downloadLink);
                }
            },
            error: () => {
                this.isPageLoading = false;
                this.messageService.displayErrorMessage('Failed to Export Data');
            }
        });
    }

    /**
     * Exports the employee work abroad details
     */
    public exportEmployeeWorkAbroadDetailsExcel(): void {
        this.isPageLoading = true;
        this.hrService.downloadEmployeeWorkAbroadDetailsExcel(this.countrySettingsCode).subscribe({
            next: (blob) => {
                this.isPageLoading = false;
                if (blob.size !== 0) {
                    const downloadLink = document.createElement('a');
                    downloadLink.href = window.URL.createObjectURL(blob);
                    downloadLink.setAttribute('download', 'Employee Work Abroad Details.xlsx');
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    document.body.removeChild(downloadLink);
                }
            },
            error: () => {
                this.isPageLoading = false;
                this.messageService.displayErrorMessage('Failed to Export Data');
            }
        });
    }

    /**
     * Passes a year string and team array to the methods to calculate vacation and work abroad card values
     * @param year The year to calculate values for
     * @param team The team to calculate values for
     */
    public calculateDisplayValues(year: string, team: string[]): void {
        this.selectedYear = year;
        this.calculateVacationCardValues(year, team);
        this.calculateWorkAbroadCardValues(year, team);
    }

    /**
     * Calculate the values of the vacation cards and displays those values
     * @param year The year to calculate values for
     * @param team The team to calculate values for
     */
    public calculateVacationCardValues(year: string, team: string[]) {
        const value = this.managerService.calculateDisplayValueOfVacation(this.dataSourceSwitchVacation.data, year, team);
        const pendingDays = this.managerService.calculatePendingDaysOfVacation(this.dataSourceVacation.data, year, team);
        this.displayValuePersonal.set('leaveEntitlement', String(value.annualLeave));
        this.displayValuePersonal.set('remainingDays', String(value.remainingDays));
        this.displayValuePersonal.set('daysUsed', String(value.daysUsed));
        this.displayValuePersonal.set('pendingRequests', String(pendingDays.pendingRequests));
        this.displayValuePersonal.set('pendingDays', String(pendingDays.pendingDays));
    }

    /**
     * Calculate the values of the work abroad cards and displays those values
     * @param year The year to calculate values for
     * @param team The team to calculate values for
     */
    public calculateWorkAbroadCardValues(year: string, team: string[]) {
        const value = this.hrService.calculateDisplayOfWork(this.dataSourceSwitchWork.data, year, team);
        const pendingWorkDays = this.hrService.calculatePendingDaysOfWork(this.dataSourceWork.data, year, team);
        this.displayValueWork.set('leaveEntitlement', String(value.annualWork));
        this.displayValueWork.set('remainingDays', String(value.remainingWorkDays));
        this.displayValueWork.set('daysUsed', String(value.workDaysUsed));
        this.displayValueWork.set('pendingRequests', String(pendingWorkDays.pendingRequests));
        this.displayValueWork.set('pendingDays', String(pendingWorkDays.pendingWorkDays));
    }

    /**
     * Calculate the values of the employee screen
     * @param team The team to calculate values for
     */
    public calculateEmployeesCard(team: string[]) {
        const employeeDetails = this.hrService.calculateCardOfEmployee(this.dataSourceEmployee.data, team, this.currentYear);
        this.displayValueEmployees.set('NumOfemployee', String(employeeDetails.employeeNum));
        this.displayValueEmployees.set('partTime', String(employeeDetails.partTime));
        this.displayValueEmployees.set('fullTime', String(employeeDetails.fullTime));
        this.displayValueEmployees.set('interns', String(employeeDetails.interns));
        this.displayValueEmployees.set('contractors', String(employeeDetails.contractors));
        this.displayValueEmployees.set('fixedTerm', String(employeeDetails.fixedTerm));
    }

    /**
     * This method takes a vacation object,
     * changes the request status to approved,
     * updates the updatedBy field,
     * and then calls the approve vacation request method in the service which makes the api call
     * @param data the vacation to be processed
     */
    public approveVacation(data: Vacation) {
        this.refreshLoading = true;
        this.stringIOFormat = false;
        data.requestStatus = 'APPROVED';
        data.updatedBy = this.gminValue;
        data.startDate = this.formatDate(data.startDate);
        data.endDate = this.formatDate(data.endDate);
        this.managerService.approveVacationRequest(data).subscribe({
            next: () => {
                this.stringIOFormat = true;
                this.refreshPersonalTable();
                this.messageService.displayMessage('success');
                const [day, month, year] = data.startDate.split('/');
                data.startDate = new Date(+year, +month - 1, +day).toISOString();
                const [dayEnd, monthEnd, yearEnd] = data.endDate.split('/');
                data.endDate = new Date(+yearEnd, +monthEnd - 1, +dayEnd).toISOString();
            }, error: (err: HttpErrorResponse) => {
                data.requestStatus = 'PENDING';
                this.messageService.displayErrorMessage(err.error.errorMessage);
            }
        });
    }

    /**
     * This method takes a string of a vacation id and declines the request
     * @param vacationValue The string is the vacation id
     */
    public openDeclineVacationPopUp(vacationValue: Vacation) {
        this.refreshLoading = false;
        this.stringIOFormat = false;
        vacationValue.updatedBy = this.gminValue;
        vacationValue.startDate = this.formatDate(vacationValue.startDate);
        vacationValue.endDate = this.formatDate(vacationValue.endDate);
        this.dialog.open(DeclinePopUpComponent,
            {data: {value: vacationValue, tag: 'personal'}}).afterClosed().subscribe(() => {
            this.stringIOFormat = true;
            this.refreshPersonalTable();
            const [day, month, year] = vacationValue.startDate.split('/');
            vacationValue.startDate = new Date(+year, +month - 1, +day).toISOString();
            const [dayEnd, monthEnd, yearEnd] = vacationValue.endDate.split('/');
            vacationValue.endDate = new Date(+yearEnd, +monthEnd - 1, +dayEnd).toISOString();
        });
    }

    /**
     * This method takes a workAbroad object,
     * changes the request status to approved,
     * updates the updatedBy field,
     * and then does the same for any vacations taken within this workAbroad request.
     * Then it calls the approve work request method in the service which makes the api call
     * @param data WorkAbroad object
     */
    public approveWork(data: WorkAbroad) {
        this.refreshLoading = true;
        this.stringIOFormat = false;
        this.isClosed = false;
        data.requestStatus = 'APPROVED';
        data.updatedBy = this.gminValue;
        data.startDate = this.formatDate(data.startDate);
        data.endDate = this.formatDate(data.endDate);
        if (data.vacations.length > 0) {
            data.vacations.forEach((dat: any) => {
                dat.requestStatus = 'APPROVED';
                dat.updatedBy = this.gminValue;
            });
        }
        this.managerService.approveWorkRequest(data).subscribe({
            next: () => {
                this.refreshLoading = false;
                this.stringIOFormat = true;
                this.refreshWorkAbroadTable();
                this.messageService.displayMessage('success');
            }, error: (err: HttpErrorResponse) => {
                data.requestStatus = 'PENDING';
                this.refreshLoading = false;
                this.refreshWorkAbroadTable();
                this.messageService.displayErrorMessage(err.error.errorMessage);
            }
        });
    }

    /**
     * This method takes a string of a workAbroad id and
     * declines the request
     * @param data the data is the workabroad id as a string
     */
    public declineWorkAbroad(data: any) {
        this.stringIOFormat = false;
        this.isClosed = false;
        data.startDate = this.formatDate(data.startDate);
        data.endDate = this.formatDate(data.endDate);
        this.dialog.open(DeclinePopUpComponent, {
            data: {
                value: data,
                tag: 'workabroad'
            }
        }).afterClosed().subscribe(() => {
            this.stringIOFormat = true;
            this.isClosed = true;
            this.refreshWorkAbroadTable();
            this.sortWorkAbroadStartDate();
        });
    }

    /**
     * This method takes a string of a workAbroad id and
     * edits the request
     * @param data the data is the workabroad id as a string
     */
    public editWorkAbroad(data: any) {
        this.dialog.open(EditWorkAbroadComponent, {
            data: {
                value: data,
                tag: 'workabroad'
            }
        }).afterClosed().subscribe(() => {
            this.refreshWorkAbroadTable();
            this.sortWorkAbroadStartDate();
        });
    }

    /**
     * This method clears the drop-down of the filter
     * @param field the data column in the table
     */
    public clearDropdown(field: string) {
        this.filterEntity[field] = new ManagerFilter()[field];
        this.calculateDisplayValues(this.selectedYear, []);
    }

    /**
     * Clear employee dropdown
     * @param field
     */
    public clearEmployeeDropdown(field: string) {
        this.employeeEntity[field] = new HrFilter()[field];
        this.calculateEmployeesCard([]);
    }

    /**
     * clear team dropdown
     * @param field
     */
    public clearTeamDropdown(field: string) {
        this.clearIconClicked = true;
        this.employeeEntity[field] = new HrFilter()[field];
        this.dataSourceTeam.data = this.teamData;
        this.filterTeamsBySelectedTeamName('');
        this.clearIconClicked = false;
    }

    /**
     * This method assigns the status whether to show the details in the UI
     */
    toggle() {
        this.show = !this.show;
        this.show ? (this.buttonName = 'Hide URL') : (this.buttonName = 'Show URL');
    }

    /**
     * This method gets all the HRDocs.
     */
    public getHrDocs() {
        let hrDocs = {} as any;
        this.hrService.getPdf().subscribe({
            next: (val) => {
                hrDocs = val;
                if (hrDocs.length > 0) {
                    this.employeeHandBookPdf = hrDocs[0];
                }
            }, error: () => {
                this.messageService.displayErrorMessage('Error getting the file');
            }
        });
    }

    /**
     * This method Updated the HR Docs.
     */
    public updatePdfDocs(pdfFile: any) {
        if (pdfFile) {
            this.employeeHandBookPdf.doc = pdfFile;
            this.employeeHandBookPdf.updatedBy = this.gminValue;
            this.hrService.updatePdf(this.employeeHandBookPdf).subscribe({
                next: () => {
                    this.messageService.displayMessage('Successfully Uploaded the PDF');
                }, error: () => {
                    this.messageService.displayErrorMessage('Failed to Upload the PDF');
                }
            });
        } else {
            this.messageService.displayErrorMessage('Enter Valid PDF');
        }
    }

    /**
     * Calls a manager service method to get an array of full names and gmin values from the employee datasource
     */
    public getEmployeeNameArray(): void {
        this.nameArray = this.managerService.getEmployeeNameArray(this.dataSourceSwitchVacation.data);
    }

    /**
     * Filters the datasources to only include entries which contain the event string in the first and last name or gmin.
     */
    public filterTableDataSources(): void {
        this.dataSourceSwitchVacation.data = this.backupVacationSwitchData;
        this.dataSourceSwitchWork.data = this.backupWorkAbroadSwitchData;
        this.dataSourceVacation.data = this.backupVacationData;
        this.dataSourceVacationAll.data = this.backupVacationDataAll;
        this.dataSourceWork.data = this.backupWorkAbroadData;
        this.dataSourceEmployee.data = this.backupEmployeeData;
        this.dataSourceSwitchVacation.data = this.managerService.filterDataSource(this.searchValue, this.nameArray, this.dataSourceSwitchVacation.data);
        this.dataSourceSwitchWork.data = this.managerService.filterDataSource(this.searchValue, this.nameArray, this.dataSourceSwitchWork.data);
        this.dataSourceVacation.data = this.managerService.filterDataSource(this.searchValue, this.nameArray, this.dataSourceVacation.data);
        this.dataSourceVacationAll.data = this.managerService.filterDataSource(this.searchValue, this.nameArray, this.dataSourceVacationAll.data);
        this.dataSourceWork.data = this.managerService.filterDataSource(this.searchValue, this.nameArray, this.dataSourceWork.data);
        this.dataSourceEmployee.data = this.managerService.filterDataSource(this.searchValue, this.nameArray, this.dataSourceEmployee.data);
        this.calculateDisplayValues(this.filterEntity.year, this.filterEntity.teamName);
        this.calculateEmployeesCard(this.employeeEntity.teamName);
    }

    public getEmployeeDisplayName(manager: string): Observable<any> {
        return this.hrService.searchForEmployees(manager).pipe(map(response => {
            if (response && response.body && response.body.length > 0) {
                const employee = response.body[0];
                employee.displayName = `${employee.firstName} ${employee.lastName}`;

                shareReplay(1);
                return employee.displayName;
            } else {
                {
                    this.messageService.displayErrorMessage('Employee Not Found');
                }
            }
        }));
    }

    formatDate(dateString: string | number | Date) {
        const date = new Date(dateString);
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    }

    /**
     * This method takes in an event of a file and updates the selected file
     * @param event the event is the file
     */
    public chooseFile(event: any) {
        this.exportAvailable = false;
        this.importCompleted = false;
        this.handleExportExcel = [];
        this.file = '';
        // Checks if an event with a file was made
        if (event.target.files[0] && event.target.files[0].name.endsWith(".xlsx")) {
            this.file = event.target.files[0];
        } else {
            this.messageService.displayErrorMessage('This is not a .xlsx file.');
        }
    }

    /**
     * This method takes in an event of a file and updates the selected file
     * @param allFiles the event is the file
     */
    public droppedFile(allFiles: File[]) {
        this.exportAvailable = false;
        this.importCompleted = false;
        this.handleExportExcel = [];
        this.file = '';
        // Only allow one file
        if (allFiles.length > 1) {
            this.messageService.displayErrorMessage('Can only do one file at a time.');
        } else if (allFiles.length == 1) {
            // Checks if file is a .xlsx file
            if (allFiles[0].name.endsWith(".xlsx")) {
                this.file = allFiles[0];
            } else {
                this.messageService.displayErrorMessage('This is not a .xlsx file.');
            }
        }
    }

    /**
     * This method reads, validates and submits the excel data
     */
    public submitExcel() {
        this.exportAvailable = false;
        this.importCompleted = false;
        let fileReader = new FileReader();
        fileReader.readAsBinaryString(this.file);

        fileReader.onload = () => {
            let workBook = XLSX.read(fileReader.result, {type: 'binary'});
            let sheetNames = workBook.SheetNames;

            // Check that headers are correct, then store in excelData
            this.excelHeadings = XLSX.utils.sheet_to_json(workBook.Sheets[sheetNames[0]], {range: 2, header: 1})[0];
            if (this.requiredExcelHeadings[0].every((val, index) => val === this.excelHeadings[index])) {
                this.isPageLoading = true;
                this.excelData = XLSX.utils.sheet_to_json(workBook.Sheets[sheetNames[0]], {range: 2});

                let finalData: ImportExcel[] = [];

                for (let row in this.excelData) {
                    let isValid = true;
                    
                    // Handle missing or blank "Is Manager" field
                    if (!this.excelData[row]['Is Manager'] || this.excelData[row]['Is Manager'].toString().trim() === '') {
                        this.excelData[row]['Is Manager'] = 'No';
                    }

                    // Checks if data is missing - HR column can be blank
                    if ((Object.keys(this.excelData[row]).length == 12 && this.excelData[row]['Is HR'] !== undefined) || 
                        (Object.keys(this.excelData[row]).length < 12) || 
                        (Object.keys(this.excelData[row]).length > 13)) {
                        isValid = false;
                    } else {
                        // Check if any cell has null or n/a values
                        for (let column in this.excelData[row]) {
                            const cellValue = this.excelData[row][column];
                            if (cellValue == 'null' || cellValue == 'n/a' || 
                                cellValue == 'NULL' || cellValue == 'N/A' || 
                                cellValue == 'Null') {
                                isValid = false;
                                break;
                            }
                        }
                    }
                    
                    if (isValid) {
                        let columnDate = new Date((this.excelData[row]['Hire Date'] - (25567 + 2)) * 86400 * 1000);
                        let columnDateToString = ("0" + (columnDate.getDate())).slice(-2) + "/" + 
                                               ("0" + (columnDate.getMonth() + 1)).slice(-2) + "/" + 
                                               columnDate.getFullYear();
                        
                        let importExcelModel = {
                            gmin: this.excelData[row]['GMIN'],
                            firstName: this.excelData[row]['First Name'],
                            lastName: this.excelData[row]['Last Name'],
                            employeeType: this.excelData[row]['Employee Type'],
                            isManager: this.excelData[row]['Is Manager'],
                            isHr: this.excelData[row]['Is HR'],
                            supervisoryOrganization: this.excelData[row]['Supervisory Organization'],
                            location: this.excelData[row]['Location'],
                            manager: this.excelData[row]['Manager'],
                            managerGmin: this.excelData[row]['Manager GMIN'],
                            managerEmailAddress: this.excelData[row]['Manager Email Address'],
                            continuousServiceDate: columnDateToString,
                            emailPrimaryWork: this.excelData[row]['Email - Primary Work'],
                            updatedByGmin: this.gminValue
                        } as ImportExcel;

                        finalData.push(importExcelModel);
                    }
                }

                // Submit data to the synchronous API
                this.hrService.saveEmployeeTeam(finalData).subscribe({
                    next: (response) => {
                        this.isPageLoading = false;
                        this.importCompleted = true; // Add this line
                        
                        // Check if response has the new format with status, successfulRows, etc.
                        if (response && typeof response === 'object' && 'status' in response) {
                            // New response format
                            if (response.status === 'COMPLETED') {
                                if (response.errorRows > 0) {
                                    // ADD DEBUGGING HERE
                                    console.log('API Response:', response);
                                    console.log('Errors array:', response.errors);
                                    console.log('Error rows count:', response.errorRows);
                                    console.log('handleExportExcel before processing:', this.handleExportExcel);
                                    
                                    this.messageService.displayErrorMessage(
                                        `Import completed with ${response.errorRows} errors out of ${response.totalRows} rows`
                                    );
                                    this.handleSyncImportErrors(response.errors || []);
                                    
                                    // ADD MORE DEBUGGING HERE
                                    console.log('handleExportExcel after processing:', this.handleExportExcel);
                                    console.log('handleExportExcel length:', this.handleExportExcel.length);
                                } else {
                                    // ADD DEBUGGING FOR SUCCESS CASE TOO
                                    console.log('Success case - no errors');
                                    console.log('API Response:', response);
                                    
                                    this.messageService.displayMessage(
                                        response.message || 'Files uploaded and details updated successfully'
                                    );
                                    this.handleExportExcel = []; // Ensure no errors for success case
                                    this.refreshEmployee();
                                }
                            } else if (response.status === 'FAILED') {
                                this.messageService.displayErrorMessage(
                                    response.message || 'Import failed'
                                );
                                this.handleSyncImportErrors(response.errors || []);
                            }
                        } else {
                            // Fallback for old response format (array of errors)
                            const errorRows = response || [];
                            if (errorRows.length > 0) {
                                this.handleSyncImportErrors(errorRows);
                            } else {
                                this.messageService.displayMessage('Files uploaded and details updated successfully');
                                this.handleExportExcel = []; // Ensure no errors for success case
                                this.refreshEmployee();
                            }
                        }
                    },
                    error: (error) => {
                        // ADD DEBUGGING HERE
                        console.log('=== HTTP Error occurred ===');
                        console.log('Error details:', error);
                        
                        this.isPageLoading = false;
                        // Don't set importCompleted = true for HTTP errors
                        // this.importCompleted = true; // Remove this line
                        
                        // Reset state so user can try again
                        this.handleExportExcel = [];
                        this.exportAvailable = false;
                        
                        // ADD DEBUGGING AFTER SETTING STATE
                        console.log('After HTTP error - importCompleted:', this.importCompleted);
                        console.log('After HTTP error - handleExportExcel.length:', this.handleExportExcel.length);
                        
                        this.messageService.displayErrorMessage('Error saving/updating employee and team details. Please try again.');
                    }
                });
            } else {
                this.isPageLoading = false;
                this.messageService.displayErrorMessage('Incorrect headers in .xlsx file.');
            }
        };
    }

    /**
     * Handles the error rows from the synchronous import response
     * @param errorRows Array of rows that had errors during import
     */
    private handleSyncImportErrors(errorRows: any[]): void {
        if (errorRows && errorRows.length > 0) {
            this.handleExportExcel = [];
            
            // ADD DEBUGGING HERE
            console.log('handleSyncImportErrors called with:', errorRows);
            console.log('Number of error rows:', errorRows.length);
            
            for (let resp of errorRows) {
                // Handle both old format (continuousServiceDate) and new format
                let continuousServiceDate = resp.continuousServiceDate || resp.hireDate;
                if (continuousServiceDate && continuousServiceDate.includes('/')) {
                    let splitContinuousServiceDateString = continuousServiceDate.split("/");
                    let continuousServiceDateString = splitContinuousServiceDateString[1] + "/" + 
                                                     splitContinuousServiceDateString[0] + "/" + 
                                                     splitContinuousServiceDateString[2];
                    let excelDate = new Date(continuousServiceDateString);
                    
                    this.handleExportExcel.push({
                        'GMIN': resp.gmin,
                        'First Name': resp.firstName,
                        'Last Name': resp.lastName,
                        'Employee Type': resp.employeeType,
                        'Is Manager': resp.isManager,
                        'Is HR': resp.isHr,
                        'Supervisory Organization': resp.supervisoryOrganization,
                        'Location': resp.location,
                        'Manager': resp.manager,
                        'Manager GMIN': resp.managerGmin,
                        'Manager Email Address': resp.managerEmailAddress,
                        'Hire Date': excelDate,
                        'Email - Primary Work': resp.emailPrimaryWork
                    });
                }
            }
            
            // ADD DEBUGGING AT THE END
            console.log('Final handleExportExcel array:', this.handleExportExcel);
            console.log('Final handleExportExcel length:', this.handleExportExcel.length);
            console.log('exportAvailable set to:', this.exportAvailable);
            
            this.exportAvailable = true;
            this.messageService.displayErrorMessage(`Import completed with ${errorRows.length} error rows. Download the error file for details.`);
        }
    }

    /**
     * Downloads the error rows from the import as an Excel file
     */
    public downloadErrorRows(): void {
        if (this.handleExportExcel && this.handleExportExcel.length > 0) {
            this.isExcelExporting = true;
            ExcelUtil.exportObjectArrayMultiThreaded(this.handleExportExcel, 'Import_Error_Rows')
                .subscribe({
                    next: (workbook) => {
                        if (workbook) {
                            writeFile(workbook, 'Import_Error_Rows.xlsx');
                            this.messageService.displayMessage('Error rows downloaded successfully');
                        }
                        this.isExcelExporting = false;
                    },
                    error: () => {
                        this.messageService.displayErrorMessage('Failed to download error rows');
                        this.isExcelExporting = false;
                    }
                });
        } else {
            this.messageService.displayErrorMessage('No error rows to download');
        }
    }

    public approveCancelRequestForVacation(data: any) {
        this.isPageLoading = true;
        this.hrService.deleteVacationRequest(data.id).subscribe({
            next: () => {
                this.isPageLoading = false;
                this.refreshPersonalTable();
            }, error: (err: HttpErrorResponse) => {
                this.isPageLoading = false;
                this.messageService.displayErrorMessage(err.message);
            }
        });
    }

    public clearSearchBox() {
        this.searchTxt = undefined;
    }
}
